import React from "react";
import injectSheet from "react-jss";
import styles from "./information_styles";

const Information = injectSheet(styles)((props) => {

    const {message} = props;

    return (
        <div className={`information ${props.classes.informationSection}`}>
       <span className={'icon'}>
           <i className="fa fa-info-circle" aria-hidden="true"></i>
       </span>
            <p className={`message`}>{message}</p>
        </div>
    )
});

export default Information;